import { useApolloClient } from '@apollo/client'
import {
  MarketplaceInstallationFragment,
  MarketplaceInstallationFragmentDoc,
} from 'generated/resources/graphql'

export const useUpdateMarketplaceInstallationCache = () => {
  const client = useApolloClient()

  const updateMarketplaceInstallationCache = (
    integrationInstallation: MarketplaceInstallationFragment,
    formData: string
  ) => {
    client.writeFragment({
      id: `MarketplaceCompanyInstallation:${integrationInstallation?.id}`,
      variables: {
        integrationDatoIds: [integrationInstallation?.integrationDatoId],
      },
      fragment: MarketplaceInstallationFragmentDoc,
      fragmentName: 'MarketplaceInstallation',
      data: {
        id: integrationInstallation.id,
        companyId: integrationInstallation.companyId,
        formData: formData,
        integrationDatoId: integrationInstallation.integrationDatoId,
        integrationId: integrationInstallation.integrationId,
      },
    })
  }

  return {
    updateMarketplaceInstallationCache,
  }
}
